import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { HistoryLogTemplate } from 'themes/components';

function ProductHistoryLogListTemplate({ productHistoryLogViewStore }) {
	const { listStore } = productHistoryLogViewStore;
	return <HistoryLogTemplate listStore={listStore}></HistoryLogTemplate>;
}

export default defaultTemplate(ProductHistoryLogListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/pages/ProductHistoryLogListTemplate.jsx